import { makeStyles } from "@material-ui/core";
import "../../style.scss";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { CopyToClipboard } from "react-copy-to-clipboard";

import React from "react";
import { InfoToast } from "../../../../shared";

type Props = {
  item: any;
};

const Text = ({ item }: Props) => {
  const useStyles = makeStyles({
    tooltip: {
      background: "#333",
      borderRadius: "20px ",
      color: "#FFF",
      padding: "8px 15px",
      fontSize: "14px",
    },
  });
  const classesToolTip = useStyles();

  const extractPlainText = (html:any) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const plainText = extractPlainText(item?.Text);


  return (
    <div>
      <label>متن پیام:</label>
      <div className="d-flex justify-content-start align-items-start" />
      <Tooltip
        title={
          <Typography
            component="div"
            dangerouslySetInnerHTML={{ __html: item?.Text }}
          />
        }
        classes={classesToolTip}
      >
        <div className="d-flex justify-content-start align-items-start" >
          <div
            className="txt-message "
            dangerouslySetInnerHTML={{ __html: item?.Text }}
          ></div>
          <CopyToClipboard
            text={plainText}
            onCopy={() => InfoToast("متن مورد نظر با موفقیت کپی شد")}
          >
            <button color="primary" type="button" className="btn btn-primary">
              کپی متن
            </button>
          </CopyToClipboard>
        </div>
      </Tooltip>
    </div>
  );
};
export default Text;
